import React from "react";
import { useTranslation } from 'react-i18next';


const LoaderOverlay = ({ loading }) => {
  const { t } = useTranslation();
  if (!loading) return null;

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm z-[1400] animate-fadeIn">
      {/* Spinner */}
      <div className="loader"></div>

      {/* Text with gradient animation */}
      <span className="loading-text">
        {t("loading")}
      </span>
    </div>
  );
}

export default LoaderOverlay;